import Copy from "@components/global/new/Copy/Copy";
import { makeColor } from "@utils/hexToRgb";
import { UserTagsService, drawTagWithoutDates } from "@utils/userTags";
import { Tag, Tooltip } from "antd";
import cn from "classnames";
import { useMemo } from "react";
import styles from "./UserTags.module.scss";
import { IUserTagsTagsProps } from "./UserTags.props";

export default function UserTags({ slicer = 1, ...props }: IUserTagsTagsProps) {
  const tags = new UserTagsService(props.tags).spliteDate().sort().tags;

  const tagsToShow = useMemo(() => {
    return tags.slice(0, slicer);
  }, [tags]);

  const hasMoreTags = useMemo(() => {
    return tagsToShow.length < tags.length;
  }, [tags, tagsToShow]);

  return (
    <Tooltip
      title={
        <div className={styles.all_tags}>
          {tags.slice(tagsToShow.length).map((t) => (
            <Copy text={drawTagWithoutDates(t)} key={t}>
              <Tag
                color={props.color}
                className={cn(styles.tag)}
                style={{
                  color: makeColor(props.color || ""),
                }}
                key={t}
              >
                {drawTagWithoutDates(t)}
              </Tag>
            </Copy>
          ))}
        </div>
      }
      open={hasMoreTags ? undefined : false}
      color='#fff'
      placement='top'
    >
      <div className={cn(styles.wrapper, props.className)}>
        {tagsToShow.map((t, i) => (
          <Copy text={drawTagWithoutDates(t)} key={i}>
            <Tag
              color={props.color}
              className={cn(styles.tag, {
                [styles.single]: tags.length - slicer >= 1,
                [styles.multiple]: tags.length - slicer > 1,
              })}
              style={{
                borderColor: props.color,
                color: makeColor(props.color || ""),
              }}
              key={t}
            >
              {drawTagWithoutDates(t)}
              {hasMoreTags ? "..." : null}
            </Tag>
          </Copy>
        ))}
      </div>
    </Tooltip>
  );
}
